import { render } from "./PasswordResetView.vue?vue&type=template&id=c91913f4&scoped=true"
import script from "./PasswordResetView.vue?vue&type=script&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&lang=js"

import "./PasswordResetView.vue?vue&type=style&index=0&id=c91913f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91913f4"]])

export default __exports__